<template>
    <v-avatar :size="size" class="p-relative overflow-visible">
        <v-img :src="img"/>
        <v-btn
            v-if="withBack"
            class="b1 btn-avatar"
            depressed small rounded
            color="#03342C" text
            @click="$router.back()"
        >
            <v-icon color="#03342C">$left_arrow</v-icon>
            {{ $t('common.back') }}
        </v-btn>
    </v-avatar>
</template>

<script>
export default {
    name: "AvatarProfile",
    props: {
        img: {
            type: String,
            default: null,
        },
        size: {
            type: [Number, String],
            default: 160,
        },
        withBack: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>

.btn-avatar {
    position: absolute;
    text-transform: capitalize;
    top: -15px;
    left: 0;
    background-color: #F9F9F9
}

</style>